import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";
import { yang } from "@/images";
const securityGuard = require("@/images/Security.png");
const gun = require("@/images/Gun.png");

const yogidDialog = [
  new Dialog(
    "SONNY YANG: Folks, there’s been a confirmed case of YOGID-19 in the building! Evacuate the premises at once!",
    yang,
    require("@/audio/Pandemic-111-Sonny-Revised-MP3.mp3")
  ),
  new Dialog(
    "SECURITY GUARD: I’ve been authorised to shoot anyone interfering with Shibari productivity and morale!",
    securityGuard,
    require("@/audio/Pandemic-110-Shibari-Guard-Revis.mp3")
  ),
  new Dialog(
    "[THE SECURITY GUARD SHOOTS YOU]",
    gun,
    require("@/audio/Defeat_Jingle.mp3")
  ),
];

const talkToEmployees = [
  new Dialog(
    "SONNY YANG: Take a walk chumps! You’ve been given the pink slip!",
    yang,
    require("@/audio/Pandemic-110-Sonny-Revised-MP3.mp3")
  ),
  new Dialog(
    "SECURITY GUARD: I’ve been authorised to shoot anyone interfering with Shibari productivity and morale!",
    securityGuard,
    require("@/audio/Pandemic-110-Shibari-Guard-Revis.mp3")
  ),

  new Dialog(
    "[The Shibari security officer shoots you in the appendix!]",
    gun,
    require("@/audio/Defeat_Jingle.mp3")
  ),
];

const convinceEmployees = [
  new Dialog(
    "SONNY YANG: Listen team, I know it my seem as though your employers have your best interests at heart but trust me when I say that the only thing Shibari International cares about is its bottom line!",
    yang,
    require("@/audio/Pandemic-112-Sonny-Revised-MP3.mp3")
  ),
  new Dialog(
    "Essential Employees: The handsome stranger is right! We shouldn’t have to risk our lives for some multinational corporation like this! Let’s all go back to our homes and try to work on our quarantine side hustles instead!",
    require("@/images/essential_employees.png"),
    require("@/audio/Pandemic-112-Employees-Revised-M.mp3")
  ),
  new Dialog(
    "[THE ESSENTIAL EMPLOYEES LEAVE THE BUILDING!]",
    require("@/images/Shibari_Office_Area.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "HR Manager: Hey you can’t all just leave in the middle of a working day! Stop! Come back!",
    require("@/images/HR_Manager.png"),
    require("@/audio/Pandemic-112-HR-Manager-Revised.mp3")
  ),
  new Dialog(
    "[The HR Manager also leaves the building!]",
    require("@/images/Shibari_Office_Area.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class EssentialEmployees extends Scene {
  title = "Essential Employees";

  async init() {
    if (this.state.storylines.employeesFled) {
      this.description = "[THE ROOM IS EMPTY]";
      this.image = require("@/images/Shibari_Office_Area.png");
      this.audio = null;
    } else {
      this.description = "Essential Employees: Yes? Can we help you?";
      this.image = require("@/images/essential_employees.png");
      this.audio = require("@/audio/Pandemic-109-Employees-Revised-M.mp3");
    }
  }

  tooGoodDialog = async () => {
    await this.dialogRunner(convinceEmployees)
    this.state.storylines.employeesFled = true;
    await this.navigate(scenes.OfficeInterior());
  };

  yogidDialog = async () => {
    await this.dialogRunner(yogidDialog)
    await this.navigate(scenes.EmergencyRoom());
  };

  firedDialog = async () => {
    await this.dialogRunner(talkToEmployees)
    await this.navigate(scenes.EmergencyRoom());
  };

  get options(): any[] {
    const choices = [
      new Choice(
        "Leave",
        async () => await this.navigate(scenes.OfficeInterior())
      ),
    ];

    if (this.state.storylines.employeesFled) {
      return choices;
    } else {
      return [
        new Choice("Tell them they’re fired", this.firedDialog),
        new Choice("Them there’s YOGID in the building", this.yogidDialog),
        new Choice(
          "Tell them they’re too good for this place",
          this.tooGoodDialog
        ),
        ...choices,
      ];
    }
  }
}

export default new EssentialEmployees();
